var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({
      position: 'absolute',
      width: _vm.mmToEm(_vm.selectedUprights.width),
      height: _vm.mmToEm(_vm.selectedHeight),
      background: _vm.gableColor,
      zIndex: 1000
    })},[_c('div',{style:({
        position: 'absolute',
        boxSizing: 'border-box',
        left: _vm.mmToEm(20),
        width: _vm.mmToEm(_vm.selectedUprights.width - 40),
        height: _vm.mmToEm(_vm.selectedHeight),
        borderRight: _vm.mmToEm(15) + ' dashed white',
        borderLeft: _vm.mmToEm(15) + ' dashed white',
        background: _vm.gableColor,
        zIndex: 1000
      })}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.includeImpactProtectors && _vm.isLeftmost),expression:"includeImpactProtectors && isLeftmost"}],style:({
        position: 'absolute',
        boxSizing: 'border-box',
        left: _vm.mmToEm(-175),
        top: _vm.mmToEm(_vm.selectedHeight - 400),
        zIndex: 1000
      })},[_c('div',{style:({
          position: 'absolute',
          height: _vm.mmToEm(120),
          width: _vm.mmToEm(75),
          top: _vm.mmToEm(20),
          background: _vm.impactProtectorColor
            
        })}),_c('div',{style:({
          position: 'absolute',
          height: _vm.mmToEm(120),
          width: _vm.mmToEm(75),
          top: _vm.mmToEm(150),
          background: _vm.impactProtectorColor
        })}),_c('div',{style:({
          position: 'absolute',
          left: _vm.mmToEm(75),
          height: _vm.mmToEm(400),
          width: _vm.mmToEm(80),
          top: _vm.mmToEm(0),
          background:
            _vm.gableColor
        })})]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.includeUprightProtectors),expression:"includeUprightProtectors"}],style:({
        position: 'absolute',
        left: _vm.mmToEm(-(150 - _vm.selectedUprights.width) / 2),
        top: _vm.mmToEm(_vm.selectedHeight - 290),
        height: _vm.mmToEm(300),
        width: _vm.mmToEm(150),
        borderTopLeftRadius: _vm.mmToEm(75),
        borderTopRightRadius: _vm.mmToEm(75),
        background: _vm.uprightProtectorColor,
        zIndex: 1020
      })})]),(_vm.isRightmost)?_c('div',{style:({
      position: 'absolute',
      left: _vm.mmToEm(_vm.sector.beam.length + _vm.selectedUprights.width),
      width: _vm.mmToEm(_vm.selectedUprights.width),
      height: _vm.mmToEm(_vm.selectedHeight),
      background:
        _vm.gableColor,
      zIndex: 1000
    })},[_c('div',{style:({
        position: 'absolute',
        left: _vm.mmToEm(20),
        width: _vm.mmToEm(_vm.selectedUprights.width - 40),
        height: _vm.mmToEm(_vm.selectedHeight),
        borderRight: _vm.mmToEm(15) + ' dashed white',
        borderLeft: _vm.mmToEm(15) + ' dashed white',
        background:
          _vm.gableColor,
        zIndex: 1000
      })}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.includeImpactProtectors && _vm.isRightmost),expression:"includeImpactProtectors && isRightmost"}],style:({
        position: 'absolute',
        boxSizing: 'border-box',
        right: _vm.mmToEm(-20),
        top: _vm.mmToEm(_vm.selectedHeight - 400),
        zIndex: 1000
      })},[_c('div',{style:({
          position: 'absolute',
          height: _vm.mmToEm(120),
          width: _vm.mmToEm(75),
          left: _vm.mmToEm(75),
          top: _vm.mmToEm(20),
          background:
            _vm.impactProtectorColor
        })}),_c('div',{style:({
          position: 'absolute',
          height: _vm.mmToEm(120),
          width: _vm.mmToEm(75),
          left: _vm.mmToEm(75),
          top: _vm.mmToEm(150),
          background:
            _vm.impactProtectorColor
        })}),_c('div',{style:({
          position: 'absolute',
          height: _vm.mmToEm(400),
          width: _vm.mmToEm(80),
          top: _vm.mmToEm(0),
          background:
            _vm.gableColor
        })})]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.includeUprightProtectors),expression:"includeUprightProtectors"}],style:({
        left: _vm.mmToEm(-(150 - _vm.selectedUprights.width) / 2),
        top: _vm.mmToEm(_vm.selectedHeight - 290),
        position: 'absolute',
        height: _vm.mmToEm(300),
        width: _vm.mmToEm(150),
        borderTopLeftRadius: _vm.mmToEm(75),
        borderTopRightRadius: _vm.mmToEm(75),
        background:
          _vm.impactProtectorColor,
        zIndex: 1020
      })})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }